import Vue from 'vue';
import PlayerMascotRegistration from './player-mascot-registration/player-mascot-registration.vue';
Vue.component('player-mascot-registration', PlayerMascotRegistration);
